import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database-deprecated';
import { storage } from 'firebase';

import { AuthService } from '../../core/auth.service';
import { ServiceBase } from '../../shared/base/service-base';

import { LessonAttachment } from './lesson-attachment';

@Injectable()
export class LessonAttachmentService extends ServiceBase<LessonAttachment> {
  constructor(db: AngularFireDatabase, private auth: AuthService) {
    super(db, '/lesson-attachments');
  }

  async upload(key: string, file: File): Promise<LessonAttachment> {
    const snapshot = await storage().ref(`/lesson-attachments/${key}/${file.name}`).put(file);
    const attachment = this.toLessonAttachment(snapshot);
    await this.readChildAsList(key).push(attachment);
    return attachment;
  }

  private toLessonAttachment({ metadata, downloadURL }): LessonAttachment {
    return Object.assign(new LessonAttachment(), {
      name: metadata.name,
      downloadURL: downloadURL,
      owner: this.auth.uid
    });
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lessons/shared/lesson-attachment.service.ts